import { FoodOrderDestinationDto } from 'Api/Features/FoodOrderDestinations/Dtos/FoodOrderDestinationDto';

export class FoodOrderDestination implements FoodOrderDestinationDto {
    constructor(dto: FoodOrderDestinationDto) {
        Object.assign(this, dto);
    }
    id = '';
    name: string | null = null;
    email: string | null = null;
}